import { KSK2101_R01Dto } from "./Dto_KSK2101_R01";
import { deleteData, getData, postData, putData } from "src/utils/axios/serverHelper";
import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { KSK2101_R01Filter } from "./Store_KSK2101_R01";
import { formatDate } from "src/utils/string/stringUtil";

const baseUrl = `${config.apiUrl}/KSK2101_R01`;

const getParams = (filter: Partial<KSK2101_R01Filter>, listLength?: number) => {
    return {
		compCd: filter.compCd,
		workplaceCd: filter.workplaceCd,
		jobTeam: filter.jobTeam,
		startDate: filter.dateRange?.from ? formatDate(filter.dateRange.from) : undefined,
		endDate: filter.dateRange?.to ? formatDate(filter.dateRange.to) : undefined,
		closeTag: filter.closeTag,
		workEmp: filter.workEmp,
		workEmpNm: filter.workEmpNm,
		workCloseShow: filter.workCloseShow,
        listLength: listLength || 0
    }
}

// 리스트 조회
export const getKSK2101_R01List = async (option: string, params: Partial<KSK2101_R01Filter>, listLength: number = 0) => {
    const url = `${baseUrl}/${option}`;
    return await getData<ResponseDto<KSK2101_R01Dto[]>>(url, { params: getParams(params, listLength) });
}

export const getKSK2101_R01AllCount = async (params: Partial<KSK2101_R01Filter>) => {
    const url = `${baseUrl}/allCount`;
    return await getData<ResponseDto<number>>(url, { params: getParams(params, 0) });
}


